import Vue from 'vue';
import { Consoler } from './Consoler';
import Axios from 'axios';

export interface ExternalSettings {
    BaseUrl: string;
    PageUrl: string;
    GoBackUrl: string;
}
export interface InternalSettings {
    ApiBaseUrl: string;
    FullConsole: string; // since modified by DevOps we can't use boolean here
}

class ConfigDefinition extends Vue {
    public ExternalSettings: ExternalSettings = {
        BaseUrl: '',
        PageUrl: '',
        GoBackUrl: ''
    };
    public InternalSettings: InternalSettings | null = {
        ApiBaseUrl: '',
        FullConsole: 'false'
    };

    private readonly SettingsFile: string = process.env.VUE_APP_SETTINGS_FILE;

    public get apiBaseUrl(): string {
        return Config.InternalSettings !== null ? Config.InternalSettings.ApiBaseUrl : '';
    }

    public async setSettings(settings: ExternalSettings) {
        Consoler.debugWarn('Setting external settings!');
        this.ExternalSettings = settings;
        await this.loadInternalSettings();
    }
    
    private loadInternalSettings(): Promise<any> {
        const settingsFileUrl = this.ExternalSettings.BaseUrl + '/' + this.SettingsFile;

        return Axios.get(settingsFileUrl)
            .then((result) => {
                this.InternalSettings = result.data.webSettings;
                Consoler.debugLog('Settings set:', this.InternalSettings, this.ExternalSettings);
            })
            .catch((error) => {
                Consoler.debugWarn('Failed reading settings file', error);
            });
    }
}

export const Config = new ConfigDefinition();